import { createAction } from '@reduxjs/toolkit';

export enum UIActionType {
  APPEND_INVALID_TEXT = 'APPEND_INVALID_TEXT',
  RESET_INVALID_TEXT = 'RESET_INVALID_TEXT',
  SET_COLOR = 'SET_COLOR',
  SET_FONT = 'SET_FONT',
  SET_IS_NO_LONGER_INITIAL_TEXT_EDIT = 'SET_IS_NO_LONGER_INITIAL_TEXT_EDIT',
  SET_TEXT = 'SET_TEXT',
}

export const setText = createAction<string>(UIActionType.SET_TEXT);
export const setColor = createAction<string>(UIActionType.SET_COLOR);
export const setFont = createAction<number>(UIActionType.SET_FONT);
export const appendInvalidText = createAction<string>(
  UIActionType.APPEND_INVALID_TEXT,
);
export const resetInvalidText = createAction(UIActionType.RESET_INVALID_TEXT);
export const setIsNoLongerInitialTextEdit = createAction(
  UIActionType.SET_IS_NO_LONGER_INITIAL_TEXT_EDIT,
);
